// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/lib-flexible'
import md5 from 'js-md5'
import { Tab, Tabs } from 'vant'
import { Popup } from 'vant';


Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);

Vue.config.productionTip = false
Vue.prototype.$md5 = md5

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js